import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { hasAnyPermissions } from 'lib/functions/utils';
import { validateProducts } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

import AccruingBook from './components/AccruingBook';
import ActiveMoney from './components/ActiveMoney';
import Alerts from './components/Alerts';
import Balances from './components/Balances';
import Collection from './components/Collection';
import IncomeBook from './components/IncomeBook';
import InvoicingBook from './components/InvoicingBook';
import Placements from './components/Placements';
import SGRWarranty from './components/SGRWarranty';
import Surpluses from './components/Surpluses';
import CurseBook from './components/TransactBook';

const Reporting: React.FC = () => {
  const { subPage } = useParams<{ page: string; subPage: string }>();
  const navigate = useNavigate();
  const handleNavigation = (index: number) => {
    navigate(`/finance/reporting/${reportsTabs[index].path}`);
  };
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const [startValue, setStartValue] = useState(0);
  const [loading, setLoading] = useState(true);

  const reportsTabs: any = [];

  if (hasAnyPermissions(user, ['reporting_active_wallet_read'])) {
    reportsTabs.push({
      label: 'Cartera',
      component: <ActiveMoney />,
      path: 'activeMoney',
      disabled: !hasAnyPermissions(user, ['reporting_active_wallet_read']),
    });
  }
  if (validateProducts(user, ['sgr'])) {
    reportsTabs.push({
      label: 'Garantías',
      component: <SGRWarranty />,
      path: 'sgrWarranty',
      disabled: !hasAnyPermissions(user, ['reporting_active_history_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_active_history_read'])) {
    reportsTabs.push({
      label: 'Colocación',
      component: <Placements />,
      path: 'placements',
      disabled: !hasAnyPermissions(user, ['reporting_active_history_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_transact_book_read'])) {
    reportsTabs.push({
      label: 'Libro curse',
      component: <CurseBook />,
      path: 'curseBook',
      disabled: !hasAnyPermissions(user, ['reporting_transact_book_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_accruing_book_read'])) {
    reportsTabs.push({
      label: 'Devengo',
      component: <AccruingBook />,
      path: 'accruingBook',
      disabled: !hasAnyPermissions(user, ['reporting_accruing_book_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_income_book_read'])) {
    reportsTabs.push({
      label: 'Flujos',
      component: <IncomeBook />,
      path: 'cashFlow',
      disabled: !hasAnyPermissions(user, ['reporting_income_book_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_alerts_read'])) {
    reportsTabs.push({
      label: 'Alertas',
      component: <Alerts />,
      path: 'alerts',
      disabled: !hasAnyPermissions(user, ['reporting_alerts_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_invoicing_book_read'])) {
    reportsTabs.push({
      label: 'Facturación',
      component: <InvoicingBook />,
      path: 'invoicingBook',
      disabled: !hasAnyPermissions(user, ['reporting_invoicing_book_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_collection_read'])) {
    reportsTabs.push({
      label: 'Recaudación',
      component: <Collection />,
      path: 'collection',
      disabled: !hasAnyPermissions(user, ['reporting_collection_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_surpluses_read'])) {
    reportsTabs.push({
      label: 'Excedentes',
      component: <Surpluses />,
      path: 'surpluses',
      disabled: !hasAnyPermissions(user, ['reporting_surpluses_read']),
    });
  }
  if (hasAnyPermissions(user, ['reporting_balances_read'])) {
    reportsTabs.push({
      label: 'Saldos',
      component: <Balances />,
      path: 'balances',
      disabled: !hasAnyPermissions(user, ['reporting_balances_read']),
    });
  }

  const setUpTabs = async () => {
    const firstAvailableTab = reportsTabs.findIndex((x: any) => !x.disabled);
    let startValueDefault = firstAvailableTab;
    startValueDefault = reportsTabs.findIndex((x: any) => x.path === subPage);
    startValueDefault =
      startValueDefault === -1 ? firstAvailableTab : startValueDefault;
    setCompanyTabs(reportsTabs);
    handleNavigation(startValueDefault);
    setStartValue(startValueDefault);
    setLoading(false);
  };

  useEffect(() => {
    void setUpTabs();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;
  return (
    <div>
      <EnhancedTab
        startValue={startValue}
        tabs={companyTabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default Reporting;
